<section class="flex w-full flex-col gap-4">
    <header class="w-full">
        <h1 class="font-display text-2xl font-bold text-text">{{ 'FUNPAY_ONBOARDING_TITLE' | translate }}</h1>
        <p class="mt-1 text-sm text-text-2">{{ 'FUNPAY_ONBOARDING_SUBTITLE' | translate }}</p>
    </header>

    @if (loading()) {
    <div class="mx-auto flex w-full max-w-4xl flex-col gap-3">
        <p-skeleton width="100%" height="3rem" />
        <p-skeleton width="100%" height="18rem" />
    </div>
    } @else if (loadError()) {
    <section class="mx-auto flex w-full max-w-4xl flex-col items-center gap-3 rounded-md bg-card p-10 text-center">
        <i class="ph ph-warning-circle text-3xl text-text-muted" aria-hidden="true"></i>
        <p class="m-0 text-sm text-text-2">{{ loadError() | translate }}</p>
        <button pButton type="button" [outlined]="true" (click)="load(id())">
            <i class="ph ph-arrow-clockwise mr-1.5"></i>
            {{ 'FUNPAY_TRY_AGAIN' | translate }}
        </button>
    </section>
    } @else if (showChoice()) {
    <section class="mx-auto grid w-full max-w-4xl grid-cols-1 gap-4 md:grid-cols-2">
        <button
            type="button"
            class="text-left flex flex-col gap-3 p-6 rounded-md border border-brand bg-concern-accent hover:shadow-md transition-shadow"
            (click)="path.set('existing'); actionError.set(null)">
            <span class="size-10 rounded-md flex items-center justify-center bg-brand text-brand-ink text-xl"><i class="ph ph-link"></i></span>
            <span class="flex items-center gap-2">
                <span class="font-display font-semibold text-lg text-text">{{ 'FUNPAY_USE_EXISTING' | translate }}</span>
                <span class="text-xs font-semibold px-2 py-0.5 rounded-pill bg-brand text-brand-ink">{{ 'FUNPAY_FASTEST' | translate }}</span>
            </span>
            <span class="text-sm text-text-2">{{ 'FUNPAY_USE_EXISTING_DESC' | translate }}</span>
            <span class="text-xs text-text-muted">{{ 'FUNPAY_EXISTING_COUNT' | translate: { count: existingAccounts().length } }}</span>
        </button>
        <button
            type="button"
            class="text-left flex flex-col gap-3 p-6 rounded-md border border-border bg-surface hover:border-border-strong transition-colors"
            (click)="path.set('new'); actionError.set(null)">
            <span class="size-10 rounded-md flex items-center justify-center bg-surface-2 text-text-2 text-xl"><i class="ph ph-plus-circle"></i></span>
            <span class="font-display font-semibold text-lg text-text">{{ 'FUNPAY_NEW_ACCOUNT' | translate }}</span>
            <span class="text-sm text-text-2">{{ 'FUNPAY_NEW_ACCOUNT_DESC' | translate }}</span>
        </button>
    </section>
    } @else if (showLinkExisting()) {
    <funpay-link-existing
        [accounts]="existingAccounts()"
        [prefill]="status()?.prefill ?? null"
        [submitting]="busy()"
        [submitError]="actionError()"
        (back)="path.set('choose')"
        (submitted)="linkExisting($event)" />
    } @else if (!showForm()) {
    <funpay-onboarding-status
        [state]="status()?.state ?? null"
        [ids]="status()?.ids ?? null"
        [busy]="busy()"
        [actionError]="actionError()"
        [canResync]="isSuperadmin()"
        (resync)="resyncAccountHolder()"
        (retry)="startOnboarding()"
        (continueOnboarding)="continueOnboarding()"
        (editDetails)="editing.set(true)" />
    } @else {
    @if (!hasStarted() && existingAccounts().length) {
    <div class="mx-auto w-full max-w-4xl">
        <button pButton type="button" severity="secondary" [text]="true" size="small" (click)="path.set('choose')">
            <i class="ph ph-arrow-left"></i>
            <span>{{ 'FUNPAY_BACK_TO_OPTIONS' | translate }}</span>
        </button>
    </div>
    }
    <funpay-onboarding-form
        [prefill]="status()?.prefill ?? null"
        [submitting]="busy()"
        [submitError]="actionError()"
        (submitted)="startOnboarding($event)" />
    }
</section>
